<div class="container-fluid scrollable main-category category">
  <div class="row category">
    <div class="col-lg-3 col-xl-3 col-md-3 col-12 d-none d-lg-block ">
      <div class="row mt-2 ml-1">
        <div class="col-12" style="background: rgba(0, 0, 0, 0.4);">
          <div class=" row">
            <div class="col-12 channel-categ-head d-flex justify-content-between">
              <div class=" pt-2 text-start d-flex-start pb-2">
                <p class="sub-text mb-0">{{'NAV.NAV7' | translate}}</p>
              </div>
              <div class="px-0 pt-2">
                <div class="d-flex-center ">
                    <ng-template #popTemplateCat>
                      <div *ngFor="let item of sortButton ;let i = index" class="mt-2">
                        <button [ngClass]="{'btn-purple': item.selected}" triggers="click" outsideClick="true" (click)="sort('category_name',item.val)" type="button"
                        class="btn sort-btn btn-dark" >
                        {{translateFilter(i) | translate }} </button>
                      </div>
                    </ng-template>
                   
                    <button type="button"  triggers="click" outsideClick="true" [popover]="popTemplateCat" class="btn tem sort-btn btn-dark"
                    placement="right">
                    <i class="fas fa-sort-alt"></i>
                  </button>
                  </div>
              </div>
            </div>
             <div class="col-12">
                      <div class="w-100">
                          <span class="icon"><i class="fa fa-search"></i></span>
                          <input type="text" class="chh-input" [(ngModel)]="searchText" id="search" (keyup)="searchTexts($event)" placeholder="{{ 'COMMON.SEARCH' | translate }}.." maxlength="255" />
                          <span class="search-x cursor-pointer text-dark" matTooltip="Clear search" *ngIf="searchText" (click)="clearSearch()"><i class="fa fa-times"></i></span>
                        </div>
                    </div>
            <div class="col-12 ">
              <div class="category-box  cat-btn" #catBox id="catBox">
                <ng-container *ngIf="searchNoData > 0 && showAll">
                  <div  class="p-2 all-categories over cursor-pointer"  [ngClass]="{'all-selected': allCatSelected}" (click)="onCategorySelect('all',true)">
                    <a class="pl-2 text-white fw-500 fs-18 a-deco" >All</a>
                  </div>
                </ng-container>
              
                <div  class="p-3 over cursor-pointer d-flex justify-content-between" id="button{{user.category_id}}"
                  [ngClass]="{'cat-selected': user.select}" *ngFor="let user of searchedLiveCatList; index as i"
                  (click)="onCategorySelect(user.category_id,true)">
                  <!-- <div class="d-flex">
                 
                    <span class="d-flex p-0 py-3 catNameResponsive marquee" [ngClass]="{'cat-selected':catSelected}">{{ user.category_name | titlecase }}</span>
                  </div> -->
                  <div class="catNameResponsive marquee-wrapper">
                  <div class="marquee-text">
                    {{ user.category_name | titlecase }}
                  </div>
                  </div>

                  <div class="live-cate d-flex">
                    <span class="search-title cursor-pointer pl-2 pr-0 py-3" style="min-width:30px"></span>
                    <span *ngIf="user.select"><i class="arrow-right"></i></span>
                  </div>
                </div>
                <div class="liveload" *ngIf="loadLiveTv">
                  <div class="d-flex align-item-center justify-content-center cursor-pointer pt-3" (click)="loadLiveTvData()" title="reload categories">
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
                      <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"/>
                      <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
                    </svg>
                    <div *ngIf="isLoading" class="spinner-border spinner-border-lg fs-34" style="vertical-align:middle;" role="status"></div>
                  </div>
                </div>
                <div class="no-data-found d-flex align-items-center justify-content-center "
               *ngIf="searchedLiveCatList.length === 0" style="height: 81vh;">
               <div class="d-flex justify-content-center align-item-center">
                <h3 class="pt-4">{{ 'COMMON.DATA_NOT_FOUND' | translate }}</h3>
              </div>
            </div>

                
                <!-- <div class="no-data-found d-flex justify-content-center" *ngIf="!isLoading && searchNoData <= 0">
                  <div class="d-flex  justify-content-center align-item-center">
                    <h5 class="pt-4">{{ 'COMMON.DATA_NOT_FOUND' | translate }} </h5>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-4 col-xl-4 col-md-4 col-12 d-none d-lg-block">
      <div class="row mt-2 ml-1">
        <div class="col-12" style="background: rgba(0, 0, 0, 0.4);">
          <div class="row">
           
             <div class="col-12  d-flex justify-content-between">

             <div class=" pt-2 text-start d-flex-start pb-2">
                <p class="sub-text mb-0 ">{{ 'NAV.CHANNEL' | translate }}</p>
              </div>
              <div class="px-0 pt-2 d-flex-end ">
                <div class="d-flex-center ">
                    <ng-template #popTemplateCats>
                      <div *ngFor="let item of sortButton ;let i = index" class="mt-2">
                        <button [ngClass]="{'btn-purple': item.selected}" (click)="sortChannel('name',item.val)" type="button"
                        class="btn sort-btn btn-dark" >
                        {{translateFilter(i) | translate }} </button>
                      </div>
                    </ng-template>
                    
                    <button type="button" triggers="click" outsideClick="true" [popover]="popTemplateCats" class="btn tem sort-btn btn-dark"
                    placement="right">
                    <i class="fas fa-sort-alt"></i></button>
                  </div>
              </div>
              </div>
             <div class="col-12">
                      <div class="w-100">
                          <span class="icon"><i class="fa fa-search"></i></span>
                          <input type="text" class="chh-input" [(ngModel)]="searchTextChannel" id="search" (keyup)="searchTextsChannel($event)" placeholder="{{ 'COMMON.SEARCH_HERE' | translate }}" maxlength="255" />
                          <span class="search-x cursor-pointer text-dark" matTooltip="Clear search" *ngIf="searchTextChannel" (click)="clearSearchChannel()"><i class="fa fa-times"></i></span>
                        </div>
                    </div>
            <div class="col-12 channelbox" id="channel-box" #channelbox (scroll)="onChannelBoxScroll($event)">
              <div class="over1 mb-3 mx-auto" [ngClass]="{'btn-selected': channel.select}" style="position: relative;"
                *ngFor="let channel of searchedChannel ;let i=index;" (click)="updateChannel(channel.stream_id,channel.links)">
                <div class="d-flex  mb-3" (click)="updateChannelEpg(channel.stream_id,channel.name,channel.stream_icon);"
                  >
                  <span class="pl-3 py-2 pr-2">
                    <img [src]="channel.stream_icon" width="70px" height="40px" class="mb-0 object-fit-cover"
                    loading=lazy>
                  </span>
                  <!-- <span class="pl-2 pr-0 py-3 channel_id">{{channel.num}}</span> -->
                  <span class=" py-3 pr-1 reschan channel-name cursor-pointer" title="{{channel.name}}">
                    {{channel.name}}
                  </span>
                  <span class="fav-icon icon-color" (click)="onSave(channel,$event)" *ngIf="!channel.channel || !channel.isFavourit"> <i
                      class="far fa-heart  cursor-pointer"></i>
                  </span>
                  <span class="fav-icon icon-color"> <i class="fas fa-heart  cursor-pointer" *ngIf="channel.is_favorite || channel.isFavourit"
                      (click)="deleteFavourite(channel,$event,i)"></i>
                  </span>
                </div>
              </div>
              <!-- <div class="not-data-fount h-100 d-flex justify-content-center align-items-center">
                  <div *ngIf="isLoading" class="d-flex-center mt-5">
                    <h3>Loading movies...</h3>
                    <i class="fas fa-spinner fa-spin ml-2"></i> 
                </div>
                </div> -->
                <div style="height: 82vh;" class="not-data-fount d-flex justify-content-center align-item-center align-items-center" *ngIf=" searchNoDatas <= 0">
                <div class="d-flex align-items-center justify-content-center align-item-center" >
                  <h3>{{ 'COMMON.DATA_NOT_FOUND' | translate }}</h3>
                </div>
                <!-- <div class="d-flex justify-content-center align-item-center" *ngIf="!Loading">
                  <h3>Loading...</h3>
                </div> -->
              </div>
              
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- d-none d-lg-block -->
    <div class="col-lg-5 col-xl-5  col-12">
      <div class="row mt-2">
        <div class="col-12 pt-0 livetv">
         <!--disablepictureinpicture-->
          <video id="live-video" class="video-js vjs-default-skin"  width="900" height="auto" style="max-width: 100%" controls autoplay  preload="auto"   controlslist="nodownload noplaybackrate">
          </video>
        
        </div>
        <div class="col-12 epg-res  d-none d-lg-block">
          <div *ngFor="let mjm of displayEpg; index as i" class="epg-box my-3 p-2 d-flex">
            <div class="col-sm-3 col-md-3 col-lg-3 pr-1 d-flex justify-content-between">
              <div class="mjm-cover" *ngIf="i === 0">
                <img [src]="channelImage" class="chh-img" alt="">
              </div>
              <div class="mjm-cover" *ngIf="i > 0">
                <div class="next-btn">
                  <button class="btn  text-white" disabled>Next</button>
                </div>
              </div>
            </div>
            <div class="col-sm-7 col-md-9 col-lg-9">
              <div class="chOrLive d-flex ">
                <div class="channel-name-epg" *ngIf="i === 0">
                  <p class="pb-0 mb-0">{{channelname || 'Name not available'}}</p>
                </div>
                <div class="ml-1">
                  <p class="live-colors" *ngIf="i === 0">Live</p>
                </div>
              </div>
              <div class="titlOrTime pl-3 d-flex justify-content-between">
                <h6 class="mb-0">{{mjm.title}}</h6>
                <div class="ml-2"><span class="text-muted">{{mjm.start }}</span> <span class="ml-1 text-muted"> -
                    {{ mjm.end }}</span>
                </div>
              </div>
              <div>
                <p class="fs-14 pl-3 mb-0 mt-1 text-muted">{{mjm.desc}}</p>
              </div>

            </div>
            
          </div>
          <div class="epg-box my-3 p-2 d-flex" *ngIf="!displayEpg.length">
            <div class="channel-image">
              <img [src]="channelImage" class="chh-img" alt="">
            </div>
            <div class="channel-name-epg">
              <p>{{channelname}}</p>
              <div class="live-color">
                <p class="fs-16">LIVE</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row d-lg-none d-block category lower">
    <div class="col-12 text-center">
      <div class="row mt-3">
        <div class="col-12 text-center" (click)="isCategory=!isCategory">
          <p class="sub-text border p-2">{{ 'COMMON.CATEGORIES' | translate }}
            <i class="fa fa-chevron-down ml-2"></i>
          </p>
        </div>
        <div *ngIf="isCategory === true" class="col-12 mx-2">
          <div class="category-box">
            <div class=" p-2 over" [ngClass]="{'btn-selected': user.select}"
            *ngFor="let user of searchedLiveCatList; index as i"
                  (click)="onCategorySelect(user.category_id,true)"  
            >
              <span class="search-title cursor-pointer pl-2 pr-0 py-3 minWidth">{{ i+1}}</span>
              <span class=" pr-0 pl-2 py-2 catImgResponsive">
                <!-- <img [src]="user.stream_icon" width="70px" height="40px" class="mb-0 object-fit-cover" loading=lazy> -->
              </span>
              <span class="">{{ user.category_name | titlecase}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row mt-3">
        <div class="col-12 text-center " style="position: relative;">
          <div class="chanel border border-white">
            <p class="sub-text my-auto py-2" (click)="isChannels=!isChannels">{{ 'COMMON.CHANNELS' | translate }}
              <i class="fa fa-chevron-down ml-2"></i>
            </p>
            <div class="col-12 channelbox" *ngIf="isChannels" id="channel-box" #channelbox (scroll)="onChannelBoxScroll($event)">
              <div class="over1 mb-3 mx-auto" [ngClass]="{'btn-selected': channel.select}" style="position: relative;"
                *ngFor="let channel of searchedChannel; index as i" (click)="updateChannel(channel.stream_id,channel.links)">
                <div class="d-flex  mb-3" (click)="updateChannelEpg(channel.stream_id,channel.name,channel.stream_icon)"
                  id="channel{{ channel.stream_id }}">
                  <!-- <span class="pl-2 pr-0 py-3 channel_id">{{channel.stream_id}}</span> -->
                  <span class="pl-2 py-2 pr-0">
                    <img [src]="channel.stream_icon" width="70px" height="40px" class="mb-0 object-fit-cover"
                      loading=lazy>
                  </span>
                  <span class="p-0 py-3 reschan search-title search-title cursor-pointer" title="{{channel.name}}">
                    {{channel.name}}
                  </span>
                  <span class="fav-icon icon-color" (click)="onSave(channel,$event)" *ngIf="!channel.channel || !channel.isFavourit"> <i
                      class="far fa-heart  cursor-pointer"></i>
                  </span>
                  <span class="fav-icon icon-color"> <i class="fas fa-heart  cursor-pointer" *ngIf="channel.is_favorite || channel.isFavourit"
                      (click)="deleteFavourite(channel,$event,i)"></i>
                  </span>
                </div>
              </div>
              <!-- <div class="over1 mb-3 mx-auto" [ngClass]="{'btn-selected': channel.select}"
                *ngFor="let channel of channels; index as i" (click)="updateChannel(channel.stream_id)">
                <div class="d-flex  mb-3" (click)="updateChannelEpg(channel.stream_id,channel.name);">
                  <div class="p-2 py-3">{{channel.stream_id}}</div>
                  <div class="p-2">
                    <img [src]="channel.stream_icon" width="90px" height="40px" class="mb-0 object-fit-cover"
                      loading=lazy>
                  </div>
                  <div class="p-2 py-3  search-title cursor-pointer" title="{{channel.name}}">
                    {{channel.name}}
                  </div>
                  <div class="p-2 py-3 ">
                    <span class="fav-icon icon-color" (click)="onSave(channel,$event)" *ngIf="!channel.isFavourit"> <i
                      class="far fa-heart  cursor-pointer"></i>
                  </span>

                  <span class="fav-icon icon-color"> <i class="fas fa-heart  cursor-pointer" *ngIf="channel.isFavourit"
                      (click)="deleteFavourite(channel,$event)"></i>
                  </span>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row mt-3">
        <div class="col-12 p-0">
          <!-- <video id="example-video" (timeupdate)="onTimeUpdate()" class="video-js  m-2" autoplay
            preload="none" controls preload="auto" width="300" height="400" data-setup='{}' style="max-width: 100%;">
            <source src="{{url}}" type="application/x-mpegURL">
          </video> -->
          <!-- <button class="btn btn-primary ml-2" (click)="openVlc(url)">Open VLC</button> -->
        </div>
        <!-- <button class="btn btn-primary m-2" (click)="copyUrl(url)">Open in VLC  <small><i class="fa fa-copy"></i></small> Copy URL</button> -->
        <div class="col-12 ml-2">
          <!-- <div *ngFor="let mjm of displayEpg; index as i" class="epg-box my-3 p-2">
            <div class="d-flex">
              <h5 class="mb-0 epg-title">{{mjm.title}}</h5>
              <div class="ml-2"><span class="text-purple">{{mjm.start }}</span> <span class="ml-1 text-purple"> -
                  {{ mjm.end}}</span>
              </div>
            </div>
            <div>
              <p class="fs-14 ml-1 mb-0 mt-1 text-muted">{{mjm.desc}}</p>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid">
  <div class="row">
    <div *ngIf="(liveCategoryList?.length<1) && (channels?.length<1)" class="col-12 empty-div d-flex-center ">
      <h5 class="pt-4">{{ 'COMMON.DATA_NOT_FOUND' | translate }} </h5>
      <p></p>
    </div>
  </div>
</div>